<div class="flex flex-col bg-gray-100">
  <div
    class="w-full px-4 border border-lgrey border-bottom border-start-0 border-end-0 border-top-0 bg-white">
    <lib-ui-header
      [headerConfig]="headerConfig"
      [infoConfig]="lastUpdatedAtConfig"
      [headerData]="{}"></lib-ui-header>
  </div>
  <div
    class="flex flex-col w-full min-h-screen p-6 gap-6 bg-gray-100 mb-[2.5rem]">
    <lib-ui-alpha-feature-enabler [clientId]="clientId" [brandId]="brandId">
      <ng-container phase="ga">
        <div class="flex flex-col gap-[1.5rem] w-full">
          @if (showBanner) {
            <m-banner
              [type]="bannerConfig.type"
              [title]="bannerConfig.title"
              [subText]="bannerConfig.subText"
              (closeBanner)="showBanner = false">
              <img
                creative
                class="w-full"
                src="/assets/images/creative/map-your-way-to-success.svg"
                alt="I" />
              <span
                class="flex items-center cursor-pointer"
                (click)="learnMore()"
                action>
                Read more about campaign mapping and how it works within
                Measured
                <span
                  class="flex items-center material-symbols-outlined ms-1 icon-small"
                  >arrow_forward</span
                >
              </span>
            </m-banner>
          }
          <div class="bg-gray-000 border border-gray-300 p-6 rounded-lg">
            <lib-taxonomy-hero-metrics
              [metricConfig]="heroMetricConfig"></lib-taxonomy-hero-metrics>
          </div>
        </div>
      </ng-container>
    </lib-ui-alpha-feature-enabler>
    <lib-ui-alpha-feature-enabler [clientId]="clientId" [brandId]="brandId">
      <ng-container phase="ga">
        <m-card>
          <lib-taxonomy-campaigns-view
            [clientId]="clientId"
            [brandId]="brandId"
            [userType]="userType"></lib-taxonomy-campaigns-view>
        </m-card>
      </ng-container>
      <ng-container phase="ai">
        <lib-taxonomy-ai-campaigns-view
          [clientId]="clientId"
          [brandId]="brandId"
          [userType]="userType"></lib-taxonomy-ai-campaigns-view>
      </ng-container>
    </lib-ui-alpha-feature-enabler>
  </div>
</div>
